import * as React from "react";

import { UNSAFE_CHARS_FOR_SLUGS } from "~/utils/constants";
import { useFormContext } from "react-hook-form";
import { Input, InputProps } from "./Input";

interface SlugInputProps extends Omit<InputProps, "name"> {
    name: string; // Make sure to include the 'name' prop for proper form registration
}

const SlugInput: React.FC<SlugInputProps> = ({ name, ...props }) => {
    const {
        register,
        setError,
        clearErrors,
        formState: { errors },
    } = useFormContext();

    // Register the input and get its field-specific methods
    const { ref, onChange, onBlur } = register(name, {
        required: "This field is required",
        validate: (value) =>
            !UNSAFE_CHARS_FOR_SLUGS.some((char) => value.includes(char)) ||
            "Invalid character for slug",
    });

    // Custom handleChange that uses the register's onChange
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (!UNSAFE_CHARS_FOR_SLUGS.some((char) => value.includes(char))) {
            clearErrors(name);
            onChange(e); // Call the register's onChange
        } else {
            setError(name, {
                type: "manual",
                message: "Invalid character for slug",
            });
        }
    };

    return (
        <div>
            <Input
                {...props}
                name={name}
                minLength={1}
                maxLength={50}
                ref={ref}
                onChange={handleChange}
                onBlur={onBlur}
                autoComplete="off"
            />
            {errors[name] && (
                <div className="text-sm text-red-500">
                    {errors[name]?.message as string}
                </div>
            )}
        </div>
    );
};

export { SlugInput };
